import { Box, Circle, Flex, HStack, Icon, Tag, Text } from "@chakra-ui/react";
import { Fragment } from "react";
import { FiCheck, FiX } from "react-icons/fi";
import { NeedStatus } from "../../autogen/bff-api";
import { useNeedStatusLabel } from "./useNeedStatusLabel";

const CANONICAL_PATH: NeedStatus[] = [
  NeedStatus.Reported,
  NeedStatus.Approved,
  NeedStatus.ProcurementCreated,
  NeedStatus.UnderProcurement,
  NeedStatus.Completed,
];

const NEGATIVE_TERMINAL: NeedStatus[] = [NeedStatus.Rejected, NeedStatus.Withdrawn];
const CALL_OFF_BRANCH: NeedStatus[] = [NeedStatus.FrameworkRecommended, NeedStatus.UnderCallOff];

export const NeedStatusStepper = ({ status }: { status: NeedStatus }) => {
  const label = useNeedStatusLabel();
  const currentIndex = CANONICAL_PATH.indexOf(status);
  const onCanonicalPath = currentIndex >= 0;
  const isNegative = NEGATIVE_TERMINAL.includes(status);
  const isCallOff = CALL_OFF_BRANCH.includes(status);

  return (
    <Box>
      <HStack spacing="0" align="flex-start">
        {CANONICAL_PATH.map((s, i) => {
          const done = onCanonicalPath && i < currentIndex;
          const current = onCanonicalPath && i === currentIndex;
          const stepBg = current || done ? "smPrimary" : "smBackground";
          const stepColor = current || done ? "white" : "smMuted";
          return (
            <Fragment key={s}>
              <Flex direction="column" align="center" minW="0" flexShrink={0}>
                <Circle
                  size="8"
                  bg={stepBg}
                  color={stepColor}
                  border="1px solid"
                  borderColor={current || done ? "smPrimary" : "smBorder"}
                  mb="2"
                >
                  {done ? (
                    <Icon as={FiCheck} boxSize="4" />
                  ) : (
                    <Text fontSize="sm" fontWeight="semibold">
                      {i + 1}
                    </Text>
                  )}
                </Circle>
                <Text
                  fontSize="xs"
                  color={current ? "smText" : "smMuted"}
                  fontWeight={current ? "semibold" : "normal"}
                  textAlign="center"
                  maxW="20"
                >
                  {label(s)}
                </Text>
              </Flex>
              {i < CANONICAL_PATH.length - 1 && (
                <Box
                  flex="1"
                  h="1px"
                  mt="4"
                  bg={done ? "smPrimary" : "smBorder"}
                  alignSelf="flex-start"
                />
              )}
            </Fragment>
          );
        })}
      </HStack>

      {(isNegative || isCallOff) && (
        <Flex justify="center" mt="4">
          <Tag colorScheme={isNegative ? "red" : "purple"} size="md">
            {isNegative && <Icon as={FiX} mr="1.5" />}
            {label(status)}
          </Tag>
        </Flex>
      )}
    </Box>
  );
};
